import { ApiProperty } from '@nestjs/swagger';
import { IsUUID } from 'class-validator';

export class FacturarDirectoDto {
  @ApiProperty({ description: 'ID de la factura ya emitida que se enlaza al presupuesto.' })
  @IsUUID()
  factura_id!: string;
}
